<template>

  <ion-row>
    <ion-col class="secondary">
      <h4>Contact Me</h4>
    </ion-col>
  </ion-row>
  <ion-row class="secondary">
      <ion-col>
          <ion-col size="auto"><strong>Phone Number</strong></ion-col>
          <ion-col size="auto">(786) 548-1650</ion-col>
      </ion-col>

      <ion-col>
        <ion-col size="auto"><strong>Email</strong></ion-col>
        <ion-col size="auto">edward.turner.careers@gmail.com</ion-col>
      </ion-col>

      <ion-col>
        <ion-col size="auto"><strong>Location</strong></ion-col>
        <ion-col size="auto">Miami, FL</ion-col>
      </ion-col>

  </ion-row>

</template>

<script>
import { IonRow, IonCol } from '@ionic/vue';

export default {
  name: 'Contact',
  components: {
    IonRow, IonCol
  }
}
</script>
